// examplePrompts — färdiga prompts som visas i ExamplesTab. Separerad
// från komponenten för react-refresh-kompatibilitet (Fast Refresh kräver
// att en fil bara exporterar komponenter eller bara icke-komponenter).

export interface ExamplePrompt {
  title: string;
  prompt: string;
}

export const EXAMPLE_PROMPTS: ExamplePrompt[] = [
  {
    title: 'E-commerce Order Processing',
    prompt: 'Build me a complete e-commerce order processing workflow as a layered diagram. Start with a root layer showing 4 collapsed groups (Order Capture, Payment, Fulfillment, Customer Service) connected sequentially. Each group should contain 3-5 blocks when expanded, with proper conditions for payment success/failure and inventory checks.',
  },
  {
    title: 'CI/CD Pipeline',
    prompt: 'Design a CI/CD pipeline as a layered flow. Root: Source Control → Build → Test → Deploy (4 collapsed groups). Inside Build: compile, lint, bundle. Inside Test: unit tests, integration tests, e2e tests (with condition blocks for pass/fail). Inside Deploy: staging → approval → production. Use connector labels for pass/fail paths.',
  },
  {
    title: 'Customer Support Escalation',
    prompt: 'Map a customer support ticket flow. Start with ticket creation, then triage (condition: severity). Branch into L1 Support, L2 Engineering, L3 Critical groups. Each group contains investigation steps, communication blocks (send-email), and resolution paths. Use webhooks for external integrations.',
  },
  {
    title: 'From Image/Diagram',
    prompt: '[Attach your image] Convert this diagram/whiteboard/architecture drawing into an EngiCoro Flow Weaver JSON. Preserve the layout, connections, and hierarchy. Use collapsed groups for any clearly separated sections. Add detailed descriptions to each block based on what you can read from the image.',
  },
  {
    title: 'From Documentation',
    prompt: '[Paste your docs] Read this documentation and create a comprehensive multi-layer workflow that visualizes the described system/process. Create a root overview with collapsed groups for each major section, and populate each group with detailed block-by-block steps.',
  },
  {
    title: 'Multi-Sheet Architecture',
    prompt: 'Create a MULTI-SHEET architecture diagram (sh-array, not single sheet) for a SaaS application. Sheet 1: Frontend (PWA, web app, mobile shells). Sheet 2: Backend (API gateway, auth, business services). Sheet 3: Data (Postgres, Redis, S3, ETL). Use cross-sheet connectors (csc) only between adjacent sheets — fsi/tsi differ by exactly 1. Color-code each sheet domain (UI green, API purple, Data cyan).',
  },
  {
    title: 'Dual-Directional Flow',
    prompt: 'Design a request/response flow between Client and Server. Use one connector with bd:true for the synchronous request→response pair. Add a second pair (Client.bottom-right → Server.bottom-left + Server.top-left → Client.top-right) for the async webhook channel. Label all connectors. NEVER reuse a port between the same blockpair — port-uniqueness rejects duplicates.',
  },
  {
    title: 'Runbook with detailed docs (dd)',
    prompt: 'Create an incident-response runbook with 6-8 blocks (detection → triage → containment → recovery → postmortem). For EACH block emit BOTH "d" (one-line summary on the card) AND "dd" (full markdown runbook content with: ## headings, ordered steps, ```bash``` code blocks for relevant CLI commands, escalation contacts, rollback criteria). The "dd" content should be substantial enough that a new on-call engineer could execute the step from the Detaljer-dialog alone.',
  },
];
